import React from "react";
import Sidebar from "../../components/Sidebar";
import { MerchantPayoutTable } from "./components/MerchantPayoutTable";

const MerchantPayouts = () => {
  return (
    <div className="flex overflow-hidden flex-col h-screen md:flex-row">
      <Sidebar />
      <div className="overflow-y-auto flex-1 p-4 bg-white md:py-7">
        <h1 className="py-4 mb-0 text-xl font-bold md:text-2xl md:mb-2">Merchant Payouts</h1>
        <p className="mb-6 max-w-3xl text-sm text-gray-600">
          Every payout from every merchant account, with the payout partner that processed it. A payout that is
          pending or processing can be re-checked with its partner, declined (the merchant is refunded) or marked
          successful.
        </p>
        <MerchantPayoutTable />
      </div>
    </div>
  );
};

export default MerchantPayouts;
